const apiUrl = process.env.REACT_APP_API_URL;

/**
 * Obtiene los documentos subidos a un aula
 */
export const GetAulaDocuments = async (id_aula: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/documents`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        });
        if (response.ok) {
            return await response.json();
        }
        return [];
    } catch (error) {
        console.error('Error al obtener documentos del aula:', error);
        return [];
    }
};

/**
 * Sube un documento al aula (va a S3)
 */
export const PostAulaDocument = async (id_aula: string, file: File) => {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/documents`, {
            method: 'POST',
            body: formData
        });
        if (response.ok) {
            return await response.json();
        } else {
            const errText = await response.text();
            throw new Error(errText);
        }
    } catch (error) {
        console.error('Error al subir documento del aula:', error);
        throw error;
    }
};

/**
 * Sube una URL externa al aula (el backend descarga su contenido y lo mete en S3)
 */
export const PostAulaUrlDocument = async (id_aula: string, url: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/documents/url`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ url })
        });
        if (response.ok) {
            return await response.json();
        } else {
            const errText = await response.text();
            throw new Error(errText);
        }
    } catch (error) {
        console.error('Error al añadir URL del aula:', error);
        throw error;
    }
};

/**
 * Elimina un documento del aula
 */
export const DeleteAulaDocument = async (id_aula: string, id_document: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/documents/${id_document}`, {
            method: 'DELETE'
        });
        return response.ok;
    } catch (error) {
        console.error('Error al eliminar documento del aula:', error);
        return false;
    }
};

/**
 * Inicia la sincronización de la base de conocimientos en AWS Bedrock
 */
export const StartBedrockSync = async (id_aula: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/sync`, {
            method: 'POST'
        });
        if (response.ok) {
            return await response.json();
        }
        return null;
    } catch (error) {
        console.error('Error al iniciar sincronización de Bedrock:', error);
        return null;
    }
};

/**
 * Obtiene el estado actual de la sincronización
 */
export const GetBedrockSyncStatus = async (id_aula: string, jobId: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/aules/${id_aula}/sync/status?jobId=${jobId}`, {
            method: 'GET'
        });
        if (response.ok) {
            return await response.text(); // Devuelve 'COMPLETE', 'IN_PROGRESS', etc.
        }
        return 'UNKNOWN';
    } catch (error) {
        console.error('Error al obtener estado de sincronización:', error);
        return 'UNKNOWN';
    }
};

/**
 * Obtiene los IDs de los documentos habilitados para una actividad concreta
 */
export const GetActivityDocuments = async (id_activitat: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/activitats/${id_activitat}/documents`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        });
        if (response.ok) {
            return await response.json(); // Devuelve una lista de IDs de documentos [1, 2]
        }
        return [];
    } catch (error) {
        console.error('Error al obtener documentos de la actividad:', error);
        return [];
    }
};

/**
 * Guarda la asociación de documentos habilitados para una actividad
 */
export const SaveActivityDocuments = async (id_activitat: string, documentIds: number[]) => {
    try {
        const response = await fetch(`${apiUrl}:8061/activitats/${id_activitat}/documents`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(documentIds)
        });
        return response.ok;
    } catch (error) {
        console.error('Error al guardar documentos de la actividad:', error);
        return false;
    }
};

